import React from "react";
import { ChatsListItemType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import { ListItem } from "../../../../widget/common/ui/Listing";
import Div from "../../../../widget/common/ui/Div";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { textCase } from "../../../../service/ui/UI";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import { BadgeCircle } from "../../../../widget/common/ui/Badge";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import AppTheme from "../../../../service/app_config/AppTheme";
import Center from "../../../../widget/common/ui/Center";
import { toLocalDate } from "../../../../service/date_service/date_service";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import AppConfigService from "../../../../service/app_config/AppConfigService";

const ChatListItem: React.FC<ChatsListItemType> = ({
  chat,
  type,
  handleClick,
  chatSelected,
}) => {
  const conversId: string = chat?.conv_id!;
  const unreadCount: number = Number(chat?.conv_settings?.unread_count ?? "0");
  const muteStatus: boolean =
    chat?.conv_settings?.mute_status === "1" ? true : false;

  const isSelected: boolean = type === 3 && conversId === chatSelected?.conv_id;

  const profileLogo: string =
    chat?.flag === "3"
      ? chat?.logo || AppConfigService.get("company_logo")
      : chat?.logo!;

  return (
    <ListItem className="border-0 py-0 px-2 px-lg-4  position-relative">
      {isSelected && (
        <div
          className="position-absolute   w-100 h-100 bgcolor-primary opacity-03"
          style={{ left: 0, right: 0, top: 0 }}
        ></div>
      )}

      <div
        role="button"
        className="d-flex align-items-center border-bottom py-2 position-relative z-index-1"
        onClick={() => handleClick(chat)}
      >
        <Div>
          <LogoRound
            url={profileLogo}
            isProfile={true}
            name={chat?.name!}
            size={type === 2 ? 55 : 43}
          />
        </Div>
        <Div className="ps-3 w-100">
          <TextBlock
            fontName="medium"
            fontSize="16_17"
            textColor="black"
            maxLine={1}
          >
            {textCase(chat?.name!)}
          </TextBlock>
          <TextBlock
            fontName="book"
            fontSize="14_15"
            textColor="theme-sublabel"
            maxLine={1}
          >
            {textCase(chat?.title!)}
          </TextBlock>
        </Div>
        <div
          style={{ minWidth: 60 }}
          className="d-flex alig-items-center justify-content-end"
        >
          <div>
            <Div className="d-flex alig-items-center justify-content-end pe-1">
              {unreadCount > 0 && (
                <Center>
                  <BadgeCircle counter={unreadCount} bgColor="primary" />
                </Center>
              )}

              {muteStatus && (
                <Center className="ms-1">
                  <IconNormal
                    name="mute"
                    color={AppTheme.red}
                    size={type === 1 ? 14 : 15}
                  />
                </Center>
              )}
            </Div>
            {chat?.date !== undefined &&
              UtilityHelper.isNotEmpty(chat?.date?.toString() ?? "") && (
                <Div className="pt-1">
                  <TextBlock
                    fontName="book"
                    fontSize="13_14"
                    textColor="theme-sublabel"
                    maxLine={1}
                  >
                    {toLocalDate(chat?.date!)}
                  </TextBlock>
                </Div>
              )}
          </div>
        </div>
      </div>
    </ListItem>
  );
};

export default ChatListItem;
